<template>
  <div class="input-container" :class="{ 'input-disabled': disabled }">
    <div v-if="label" class="label-wrapper">
      <label class="label-text" :class="smallLabel ? 'label-text-small' : ''">{{ label }}</label>
    </div>
    <div class="input-field-wrapper">
      <div class="input-field">
        <div class="input-control">
          <div :class="exchangeInfo ? 'input-flex' : ''">
            <Money
              name="affiliate"
              v-show="amount !== null"
              v-bind="config"
              v-model="amount"
              class="input-element form-control"
              :class="[
                { 'input-transparent': transparentStyle },
                {
                  'is-invalid':
                    fields['affiliate'] && errors.first('affiliate') && !fields['affiliate'].valid && isBlurred,
                },
              ]"
              :style="{ width: exchangeInfo ? inputWidth : '' }"
              :required="required"
              :disabled="disabled"
              v-validate="rules"
              :placeholder="placeholder"
            />
            <span
              v-show="fields['affiliate'] && errors.first('affiliate') && !fields['affiliate'].valid && isBlurred"
              class="invalid-feedback"
              >{{ errors.first('affiliate') }}</span
            >
            <transition name="fade" :duration="300">
              <div
                v-if="icon"
                :key="icon"
                class="icon-container"
                :class="[
                  smallIcon ? 'icon-small' : 'icon-large',
                  iconPosition === 'left' ? 'icon-left-margin' : 'icon-right-margin',
                ]"
              >
                <img class="icon-image" :src="icon" filled />
              </div>
            </transition>
            <input
              v-show="amount === null"
              v-model="amount"
              class="input-element"
              v-bind="config"
              :required="required"
              :disabled="disabled"
              :placeholder="placeholder"
            />

            <span v-if="exchangeInfo" class="exchange-info-text">{{ exchangeInfo }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money';

export default {
  props: {
    value: {
      type: [String, Number],
      default: 0,
    },
    rules: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    smallLabel: {
      type: Boolean,
      default: false,
    },
    transparentStyle: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    smallIcon: {
      type: Boolean,
      default: false,
    },
    iconPosition: {
      type: String,
      default: 'left',
    },
    decimal: {
      type: String,
      default: ',',
    },
    thousands: {
      type: String,
      default: '.',
    },
    prefix: {
      type: String,
      default: '₺ ',
    },
    suffix: {
      type: String,
      default: '',
    },
    precision: {
      type: Number,
      default: 2,
    },
    masked: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    exchangeInfo: {
      type: String,
      default: undefined,
    },
  },
  components: {
    Money,
  },

  data() {
    return {
      isBlurred: false,
    };
  },

  computed: {
    config() {
      return {
        decimal: this.decimal,
        thousands: this.thousands,
        prefix: this.prefix,
        precision: this.precision,
        masked: this.masked,
      };
    },
    inputWidth() {
      const baseWidth = 120;
      const charWidth = 11.5;
      const valueLength = this.amount ? String(this.amount).length : 0;
      return `${Math.max(baseWidth, valueLength * charWidth + 32)}px`;
    },
    amount: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
        this.isBlurred = true;
      },
    },
  },

  methods: {
    checkBlur() {
      this.isBlurred = true;
    },
  },
};
</script>

<style scoped>
.field {
  display: block;
  min-width: 100px;
}

.disabledInput {
  opacity: 0.8;
  cursor: not-allowed;
}

.label-text {
  font-size: 1rem;
}

.label-small-text {
  font-size: 0.875rem;
}

.has-icons-right {
  position: relative;
  input {
    padding-right: 40px;
  }
}
.has-icons-left {
  position: relative;
  input {
    padding-left: 40px;
  }
}
.has-icons-left-big {
  position: relative;
  input {
    padding-left: 44px;
  }
}

.input-container {
  display: block;
  width: 100%;
  &.input-disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}

.label-wrapper {
  margin-bottom: 8px;
}
.label-text {
  font-size: 1rem;
  color: #333;
}
.label-text-small {
  font-size: 0.875rem;
}

.input-field-wrapper {
  display: flex;
  flex-direction: column;
}

.input-control {
  position: relative;
}

.input-flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.input-element {
  padding: 0 1rem;
  height: 3rem;
  border-radius: 4px;
  width: 100%;
  &.input-transparent {
    padding: 0;
    height: 2rem;
    background-color: transparent;
    border: none;
  }
}

.icon-container {
  position: absolute;
  display: flex;
  align-items: center;
  top: 0;
  height: 3rem;
}
.icon-left-margin {
  left: 0;
  margin-left: 0.75rem;
}
.icon-right-margin {
  right: 0;
  margin-right: 0.75rem;
}
.icon-small {
  font-size: 1.25rem;
}
.icon-large {
  font-size: 1.5rem;
}

.icon-image {
  display: inline-block;
}
.icon-text {
  font-size: 1rem;
}

.exchange-info-text {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: -0.1rem;
}
</style>
